import { render, staticRenderFns } from "./EmailFollowup.vue?vue&type=template&id=cfbee92c&"
import script from "./EmailFollowup.vue?vue&type=script&lang=js&"
export * from "./EmailFollowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports